import callRecordingTransformHelper from "./callRecordingTransformHelper"
import { convertQueryObjToString } from "utils"
import parentApi from "store/parentApi"

const callRecordingApi = parentApi.injectEndpoints({
  endpoints: build => ({
    // Get callRecording Details
    getCallRecords: build.query({
      query: ({ page, pageLimit, callType, date, ...params }) => {
        const param = { ...params }
        const callRecordingsFilter = date?.split(",")
        if (!!param.staffList) {
          let childIdentifierKey = "staffList_withoutChildren"
          param.staffList = encodeURIComponent(
            `{"teamIds":[],"userIds":[${decodeURIComponent(param.staffList)}],"includeAllChildren":${!params?.[
              childIdentifierKey
            ]}}`
          )
        }
        delete params["staffList_withoutChildren"]
        return `phoneCalls/search?isStaffHierarchy=false&${convertQueryObjToString({
          ...param,
          ...(callRecordingsFilter?.[1] && { toDate: encodeURIComponent(callRecordingsFilter[1]) }),
          ...(callRecordingsFilter?.[0] && { fromDate: encodeURIComponent(callRecordingsFilter[0]) }),
          ...(callType !== "all" && callType && { callType }),
          page: page,
          pageLimit: pageLimit,
          ...(!(param.reportType === "affiliate") && { load: "analysis" }),
        })}`
      },
      transformResponse: response => callRecordingTransformHelper(response),
    }),

    getCallTags: build.query({
      query: () => `phoneCalls/callTags`,
      transformResponse: response => response.map(e => ({ ...e, value: e.id + "", label: e.title })),
    }),
  }),
})
export const { useLazyGetCallRecordsQuery, useGetCallRecordsQuery, useLazyGetCallTagsQuery } = callRecordingApi
